export default __webpack_public_path__ + "static/media/PhaseLogo.4b6d295d.png";